/**
 *
 * @type {{courses: string, submit: string, password_label: string, about: string, create_an_account: string, my_profile: string, required: string, log_in: string, email_label: string, country_label: string, existing_user: string, explore_courses: string, sign_in: string, sign_out: string}}
 */
const common = {
  app_title: 'Formação Online em Gestão de Nível Médio',
  explore_courses: 'Explorar Cursos',
  create_an_account: 'Criar uma conta',
  existing_user: 'Utilizador existente?',
  log_in: 'Iniciar Sessão',
  sign_in: 'Iniciar Sessão',
  sign_out: 'Sair da sessão',
  my_profile: 'Meu Perfil',
  courses: 'Cursos',
  about: 'Sobre',
  submit: 'Enviar',
  email_label: 'E-mail',
  country_label: 'País',
  required: 'Todos os campos são obrigatórios',
  password_label: 'Senha',
  undo: 'Anular',
  retry: 'Tentativa',
  course_sequence_name: 'Curso {sequence}: {name}',
  newest: 'Mais recente',
  most_popular: 'Mais Populares',
  first_name_label: 'Primeiro Nome',
  last_name_label: 'Apelido',
  role_label: 'Cargo',
  role_name_label: 'Nome do Cargo',
  photo: 'Foto',
  upload_new: 'Carregar nova',
  continue_: 'Continuar',
  required_field_message: 'Este campo é obrigatório',
  dismiss: 'Despedir',
  expired_session_message: 'A sua sessão expirou. Por favor, faça o login novamente',
  saved: 'Guardado',
  yes: 'Sim',
 




};

/**
 *
 * @type {{h1: string}}
 */
const nav = {
  h1: 'Formação Online de GNM'
};

/**
 *
 * @type {{subscribe_label: string, subscribe: string, who_office: string, links: string, telephone: string, fax: string, updates: string, subscribe_placeholder: string}}
 */
const footer = {
  links: 'Links',
  who_office: 'Organização Mundial da Saúde - Escritório Regional para a África Cité du Djoué, Caixa Postal 06 Brazzaville República do Congo',
  telephone: 'Telefone',
  fax: 'Fax',
  updates: 'Actualizações',
  subscribe_label: 'Por favor, inscreva-se para receber actualizações sobre coisas relacionadas com os cursos de GNM.',
  subscribe: 'Subscrever',
  subscribe_placeholder: 'Seu endereço de e-mail',
  subscribe_success_message: 'O seu pedido para ser adicionado à lista de e-mails foi enviado',
};

/**
 *
 * @type {{p: string, enroll_course: {small: string, p: string, h3: string}, h1: string, enroll_master: {small: string, p: string, h3: string}, h3: string, welcome: string}}
 */
const home_page = {
  welcome: 'Bem-vindo à',
  h1: 'Formação Online em Gestão de Nível Médio do PAV',
  line_1: `
  Progrida na sua carreira aprendendo as competências técnicas e de gestão essenciais necessárias para realizar um programa
  de vacinação a qualquer nível. Formação de GNM está agora disponível como uma série de 15 cursos online interactivos
  que as pessoas podem fazer gratuitamente, ao seu próprio ritmo, quando e onde quiserem.
  `,
  line_2: `
  Em cada curso, os estudantes ganham experiência prática, trabalhando com cenários e exemplos realistas.
  Após cada curso, os estudantes recebem a certificação da OMS AFRO, que permite um melhor desempenho no
  trabalho e o potencial para a progressão na carreira.
  `,
  enroll_master: {
    small: 'FAZER TODOS OS 15 CURSOS',
    h3: 'Inscrever-se no Programa de Mestre',
    p: `
      Inscreva-se no Programa de GNM Mestre se estiver interessado em fazer todos os 15 cursos online e
      dominar todas as habilidades necessárias para liderar e operar um programa de vacinação.
      Leve todo o tempo necessário para concluir o programa, um curso de cada vez.
    `,
  },
  enroll_course: {
    small: 'FAZER CADA CURSO',
    h3: 'Inscreva-se Num Curso de Cada Vez',
    p: `
      Subscreva-se para um ou mais cursos online. Pode fazer poucos ou muitos que quiser, para aprender ou
      melhorar as suas habilidades. Inscreva-se em cursos adicionais a qualquer momento e leve o tempo que for necessário. Se,
      eventualmente, fazer todos os 15 cursos, receberá a certificação de mestre.
    `,
  },
  h3: 'Melhore o seu desempenho no trabalho com os cursos de Formação Online de GNM'
};

/**
 *
 * @type {{frequently_asked_questions: string, faqs: {"0": {head: string, body: string}, "1": {head: string, body: string}, "2": {head: string, body: string}, "3": {head: string, body: string}, "4": {head: string, body: string}, "5": {head: string, body: string}}, h1: string}}
 */
const help_page = {
  h1: 'Ajuda',
  frequently_asked_questions: 'Perguntas Mais Frequentes',
  faqs: {
    0: {
      slug: 'technology',
      head: 'De que tecnologia precisa para concluir os cursos?',
      body: `
      <p class="text-sm lg:text-base lg:w-9/12 py-3">
      Precisará de estar conectado à internet para fazer um curso. Além
      disso, estes cursos são concebidos para serem realizados num computador de mesa ou
      portátil usando uma versão recente do Chrome, Safari ou Firefox.
      <strong
        > note que a velocidade da Internet podem influenciar a sua capacidade de
        percorrer os módulos do curso</strong
      >.
        </p>
      `,
      subcategories: [
      ]
    },
    1: {
      slug: 'advancing',
      type: 'plain',
      head: 'Está a ter problemas para inserir uma resposta ou avançar para a próxima actividade?',
      body: ``,
      subcategories: [
          {
              slug: 'internet',
              head: 'Internet',
              body: `Isto é um problema da internet. Note que as velocidades da Internet podem 
              influenciar a sua capacidade de percorrer o curso. 
              Se constatar que está a ter problemas para continuar para o próximo ecrã, 
              <strong>verifique a sua ligação à Internet, limpe o seu cache e actualize a sua página conforme necessário.</strong>`
          }
      ]
    },
    2: {
      slug: 'understanding',
      type: 'columns',
      head: 'Está a ter problemas para entender o conteúdo do curso?',
      body: ``,
      subcategories: [
          {slug: 'hint',
           head: 'Use a função "Dica".',
           image: 'help-hint.jpg',
           body: `
           Encorajamos que a use as funções <strong>"dica"</strong>,
                quando estiverem disponíveis. Se não tiver mais "dicas"...
                disponíveis, pode reiniciar a actividade e as suas
                <strong>"dicas"</strong> será reinicializadas. Será útil tomar nota
                das respostas que já concluiu antes de reiniciar
                a actividade. Apenas a actividade actual será reiniciada; o seu
                progresso anterior permanecerá intacto.
           `},
           {slug: 'discussionboard',
           head: 'Use o Fórum de Discussão',
           image: 'help-discussionboard.jpg',
           body: `
           Se não conseguiu obter a resposta a partir das "dicas".
                dadas, encorajamos que leia os comentários publicados
                no fórum de discussão dentro do curso que está a fazer.
                Os seus colegas podem ter enfrentado o mesmo problema e oferecido
                soluções. Se não vir nenhuma sugestão dos seus colegas,
                publique uma pergunta no fórum de discussão.
           `},
           {slug: 'resources',
           head: 'Use os Recursos do Curso',
           image: 'help-resources.jpg',
           body: `
           Cada curso contém uma secção de "Recursos". Aqui vai encontrar
           vários materiais suplementares aprovados pela OMS, disponíveis para
           baixar. Se está a ter problemas para entender um curso, ou
           se tiver perguntas fora do âmbito do curso,
           reveja os recursos fornecidos.
           `},
           {slug: 'content',
           head: 'Identificou um erro no conteúdo?',
           body: `
           Os cursos de GNM são baseados em documentos de orientação aprovados pela OMS, que são revistos e actualizados em intervalos regulares. Além disso, todo o conteúdo do curso foi cuidadosamente revisto por especialistas na matéria da OMS. Se acha que identificou um erro, comece por publicar um comentário no fórum de discussão e peça a opinião dos seus colegas.
           `},
      ]
    },
    3: {
      slug: 'howworks',
      type: 'stacked',
      head: 'Como funciona a Formação de GNM Online?',
      body: ``,
      subcategories: [
          {
              slug: 'enroll',
              head: 'Como se inscrever num curso?',
              image: 'help-enroll.jpg',
              body: `<p class="mb-4">
              Para se inscrever num curso, clique no botão "Inscrição" cor de laranja.
              Pode se inscrever em um ou mais cursos em que está
              interessado, ou pode optar por fazer todos os 15
              cursos de GNM para certificação de mestrado. A escolha é sua.
            </p>
            <p>
              Depois de clicar no botão Inscrever, será solicitado a fornecer
              algumas informações de registo sobre si, o seu cargo e
              localização. Depois podes começar a fazer o curso.
            </p>`,

          },
          {
            slug: 'earn',
            head: 'Como se ganha um certificado de curso?',
            image: '',
            body: `<p class="mb-4">
            Receberá um certificado formal do Escritório Regional
            da OMS para a África logo depois de terminar um curso e
            passar a avaliação.
            <strong
              > precisará de ter pelo menos 80% para passar. </strong
            >
            Receberá um certificado para cada curso que concluir. Por
            exemplo, se concluir três cursos, receberá três
            certificados separados.
          </p>`,

        },
        {
            slug: 'access',
            head: 'Como acede ao seu certificado?',
            image: 'help-completed.jpg',
            body: `<p class="mb-4">
            Depois de passar uma avaliação, verá o curso
            listado no seu painel sob "Cursos Concluídos". Além do
            curso concluído, verá um botão em que vai clicar para baixar
            o seu certificado.
          </p>`,

        },
        {
            slug: 'master',
            head: 'Como ganha a certificação de mestre?',
            image: 'help-downloadmaster.jpg',
            body: `<p class="mb-4">
            Se concluiu todos os 15 cursos de GNM, a sua certificação de mestre aparecerá no topo da página "cursos".  
            Se ainda não conseguir aceder ao seu certificado, é provável que tenha recebido uma pontuação de avaliação <strong>inferior a 80%</strong>. 
            Reveja as suas notas em todos os 15 cursos para confirmar que recebeu uma nota de passagem. 
            Depois de concluir todos os 15 cursos de GNM, <strong>um link para baixar seu certificado ficará disponível abaixo da imagem do troféu verde na sua 
            Página "Cursos".</strong>  
        </p>
        <p class="mb-4">Este link o irá levá-lo à sua certificação de mestre: <a href="/en/courses">https://app.who-afro-mlm.com/pt/cursos</a> </p>
        `,

        },
      ]
    },
    4: {
        slug: 'profile',
        type: 'double-stacked',
      head: 'Precisa de actualizar o seu nome, senha, foto ou cargo?',
      body: ``,
      subcategories: [
          {
              slug: 'name',
              head: 'Para alterar o nome que aparece no seu certificado',
              body: `<ul class="mb-4 list-disc ml-5">
              <li class="mb-2">Faça o login na sua conta de GNM</li> 
              <li class="mb-2">Clique no seu Nome (exibido
              no canto superior direito da página).</li> 
              <li class="mb-2">Seleccione "Editar Perfil".</li>
              <li class="mb-2">No campo intitulado "Nome", digite o seu nome do jeito que
              gostaria que aparecesse no seu certificado de GNM.</li> 
              <li class="mb-2">Para evitar mudar
              a sua senha, não digite nada na secção"Redefinir senha".
              .</li> 
              <li class="mb-2">Também encorajamos que carregue uma foto de perfil
              para a sua conta!</li> 
              <li class="mb-2">Guarde as suas alterações clicando no botão "Salvar
              Alterações" botão. Note que o nome na sua conta
              vai aparecer no seu certificado. Pode ir para a sua conta
              e alterar o seu nome, no entanto, note que isto pode ser
              feito apenas uma vez num período de 3 meses.</li>
              </ul>`,
              image: 'help-profile.jpg',
              hiddenimage2: 'help-profile-editprofile.jpg'
          },
          
        {
            slug: 'password',
            head: 'Para redefinir a sua senha',
            body: `<ul class="mb-4 list-disc ml-5">
            <li class="mb-2">Visite o site de GNM e clique em "iniciar sessão". </li>
            <li class="mb-2">Então clique no texto azul que diz "Esqueceu a sua senha"? </li>
            <li class="mb-2">Depois de digitar o seu e-mail e clique no botão redefinir de cor amarela,
          receberá um e-mail que dá instrução sobre como redefinir a sua
          senha. </li>
          <li class="mb-2">Depois que isso estiver concluído, será capaz de iniciar a sessão
          na sua conta.</li>
        </ul>`,
            image: 'help-profile-editpassword.jpg',
            hiddenimage1: 'help-profile.jpg'
        },
        {
          slug: 'photo',
          head: 'Para alterar a sua foto ou o seu cargo',
          body: `<ul class="mb-4 list-disc ml-5">
          <li class="mb-2">Inicie a sessão na sua conta de GNM</li> 
          <li class="mb-2">Clique no seu Nome no canto superior direito da página.</li> 
          <li class="mb-2">Seleccione "Editar Perfil".</li> 
          <li class="mb-2">Para adicionar ou alterar a sua foto, seleccione "Carregar a nova foto".
          </li> 
          <li class="mb-2">Para adicionar ou alterar o seu cargo, seleccione o menu pendente intitulado "Cargo".</li>
        </ul>`,
          image: 'help-profile-editprofile.jpg',
          hiddenimage1: 'help-profile.jpg'
      },
      ]
    },
  }
};

/**
 *
 * @type {{"0": {p: string, button: string, h1: string}, "1": {p: string, button: string, h1: string}}}
 */
const about_page = {
    section_1: {
      h1: 'Sobre os Cursos de GNM',
      p: `
        Melhore o seu desempenho no trabalho, fazendo um ou mais dos 15 cursos separados listados abaixo.
        Em cada curso, receberá prática relevante, retroinformação individualizada, um conjunto de
        recursos e fichas de trabalho e acesso a uma comunidade de estudantes como você.
        Clique em qualquer curso para ver o que é coberto. Depois começa a aprender.
      `,
      button: 'Ir para os Cursos'
    },
    section_2: {
      h1: 'Certificação do Próximo Nível com o Programa de Mestrado de GNM',
      line_1: `
      Melhore a sua carreira inscrevendo-se no Programa de Mestrado e GNM. Depois de se inscrever,
      será automaticamente subscrito para todos os 15 cursos apresentados abaixo.
      Leve todo o tempo que precisar para concluir o curso.
      `,
      line_2: `
      Ao longo do programa, receberá prática relevante, retroinformação individualizada,
      um conjunto de recursos e fichas de trabalho da OMS, e acesso a uma comunidade de estudantes como você.
      Quando terminar, receberá a Certificação de Mestrado da OMS AFRO,
      uma designação que demonstra o seu domínio e compromisso.
      `,
      button: 'Explorar todos os Cursos'
    },
  };

/**
 *
 * @type {{est_time: string, you_are_enrolled: string, completed_courses: string, all_mlm_courses: string, view_details: string, enroll_master: string, enrolled_courses: string, enroll_in_courses: string, complete_the_remaining_n_courses: string, what_do_you_want_to_learn_about: string, continue_course: string, course_sequence_name: string, you_have_completed_all_courses: string, you_can_retake_courses_anytime: string, search_error_message: string, download_master_cert: string, you_have_completed_n_courses: string, my_courses: string, mlm_master_cert: string, download_cert: string, course_sequence: string, improve_your_performance: string, see_your_courses_below: string, start_course: string, enroll_success_message: string, great_start: string, search_results: string, n_courses: string, progress: string, enroll: string}}
 */
const courses_page = {
  improve_your_performance: 'Melhore o seu desempenho no trabalho com os cursos de Formação Online de GNM',
  enroll_in_courses: 'Inscreva-se num dos cursos abaixo, ou inscreva-se no programa de Certificação de Mestrado de GNM.',
  great_start: 'Criar uma conta é um bom começo! Está a caminho de obter a certificação de GNM.',
  you_are_enrolled: 'Sucesso! Está inscrito no programa de Certificação de Mestrado de GNM e a caminho de obter a certificação.',
  see_your_courses_below: 'Veja a sua lista de cursos abaixo.',
  n_courses: '{n} curso | {n} cursos',
  you_have_completed_n_courses: 'Continue com o bom trabalho! Concluiu {courses} até agora.',
  complete_the_remaining_n_courses: 'Conclua os restantes {courses} para se tornar um GNM Mestre e Credenciado .',
  you_have_completed_all_courses: 'Parabéns! Concluiu todos os cursos do Programa de Certificação de Mestrado de GNM',
  you_can_retake_courses_anytime: 'Não se esqueça de manter os seus conhecimentos frescos. Pode fazer cursos novamente a qualquer momento.',
  download_master_cert: 'Baixar o Certificado de Mestrado',
  download_cert: 'Baixar o Certificado',
  search_results: 'Resultados da Pesquisa',
  all_mlm_courses: 'Todos os Cursos De GNM',
  what_do_you_want_to_learn_about: 'Sobre o que quer aprender?',
  course_sequence: 'CURSO {sequence}',
  course_sequence_name: common.course_sequence_name,
  view_details: 'Ver detalhes',
  est_time: 'Tempo Est. {time}',
  estimated_time: 'Tempo Estimado',
  enroll: 'Inscrição',
  enroll_now: 'Inscreva-se Agora',
  mlm_master_cert: 'Certificação de Mestrado de GNM',
  enroll_master: `Inscreva-se em todos os 15 cursos de uma vez. Leve todo o tempo que precisar para concluir o curso. Quando
                  concluir, receberá o Certificado de Mestra da OMS AFRO.`,
  search_error_message: 'A sua pesquisa não devolveu nenhum módulo. Tente outra busca.',
  my_courses: 'Meus Cursos',
  enrolled_courses: 'Cursos Inscritos',
  progress: 'Progresso',
  completed_courses: 'Cursos Concluídos',
  retake_course: 'Retomar o Curso',
  continue_course: 'Continuar o Curso',
  start_course: 'Iniciar o Curso',
  enroll_success_message: 'Está inscrito em {course_sequence_name}',
  module_available_soon: 'Este módulo estará disponível em breve',
  master_enroll_error_message: 'Ocorreu um erro, alguns cursos não foram inscritos',
  master_un_enroll_error_message: 'Ocorreu um erro, algumas inscrições não foram anuladas.',
  master_enroll_success_message: 'Está inscrito em todos os 15 Cursos',
  lessons: 'Aulas',
  view_my_results: 'Ver os meus resultados',
  course: 'Curso',
  date_completed: 'Data de Conclusão',
  results: 'Resultados',
  course_results: 'Resultados do Curso',
  for: 'para',
  new_courses: 'Começar em Abril de 2021, um novo curso, intitulado 2YL and Beyond, também será exigido para a certificação de mestrado de GNM.',
};

/**
 *
 * @type {{return_to_my_courses: string, hide_menu: string, ask_your_question_below: string, ask_an_expert: string, ask_question_here: string, restart: string, start: string, submit_question: string, resources: string, show_menu: string, no_more_activities: string, ask_expert_success_message: string}}
 */
const course_page = {
  ask_expert_success_message: 'A sua mensagem foi enviada',
  no_more_activities: 'Não há mais actividades neste curso',
  hide_menu: 'Ocultar menu',
  show_menu: 'Mostrar menu',
  restart: 'Reiniciar',
  next_up: 'Próximo Passo',
  start: 'Início',
  return_to_my_courses: 'Voltar aos Meus Cursos',
  resources: 'Recursos',
  ask_an_expert: 'Pergunte a um especialista',
  ask_your_question_below: 'Faça sua pergunta abaixo para entrar em contacto com um especialista na matéria e dará seguimento em breve com um e-mail.',
  ask_question_here: 'Faça aqui uma pergunta',
  submit_question: 'Submeter Pergunta',
  discussion_board: 'Fórum de Discussão',
  add_comment: 'Adicionar comentário',
  sort_by: 'Ordenar por:',
  view_n_more_comments: 'Ver {n} mais comentários',
  reply: 'Resposta',
  reply_to_author: 'Responder a @{author}',
  share: 'Partilhar',
  like_this: 'Gostar',
  liked: 'Gosto',
  need_help: 'Precisa de Ajuda?',
};

/**
 *
 * @type {{profile_information: string, edit_profile: string}}
 */
const profile_page = {
  edit_profile: 'Editar perfil',
  profile_information: 'Informações de Perfil',
};

/**
 *
 * @type {{}}
 */
const profile_edit_page = {
  profile_settings: 'Configurações de perfil',
  profile: 'Perfil',
  reset_password: 'Redefinir a Senha',
  return_to_profile: 'Voltar ao perfil',
  first_name_label: common.first_name_label,
  last_name_label: common.last_name_label,
  country_label: common.country_label,
  role_label: common.role_label,
  role_name_label: common.role_name_label,
  email_label: 'Endereço de e-mail',
  mobile_phone_label: 'Telemóvel',
  save_changes: 'Salvar as alterações',
  cancel: 'Cancelar',
  new_password_label: 'Nova Senha',
  confirm_password_label: 'Confirmar a Senha',
  reset_success_response: 'O seu link de redefinição foi enviado! Verifique o seu e-mail.',
  send_reset_link: 'Enviar o link de redefinição'
};

/**
 *
 * @type {{}}
 */
const survey_page = {
  please_message: 'Preencha este inquérito com base nas suas experiências desde que iniciou o curso.',
  thanks_message: 'Obrigado por preencher o inquérito.',
  h1: '{name}, concluiu com sucesso {module}',
  h2: 'Formação Online de GNM da OMS AFRO: Inquérito Online',
  line_1: 'Este pequeno inquérito ajudará o programa OMS AFRO IVD a entender melhor como o material do curso de GNM é utilizado no trabalho diário dos gestores do programa de vacinação de nível médio.',
  line_2: `Além disso, esta etapa foi incorporada como um requisito para receber a certificação pela
  formação. Pedimos gentilmente que preencha este questionário de 9 perguntas, que não leva mais de 10
  minutos. Depois de concluir o inquérito, receberá a certificação da OMS AFRO pela
  formação concluída.`,
  line_3: 'Obrigado por dedicar o seu tempo para dar as suas experiências.',
  capable_label_line_1: 'Até que ponto este curso online de GNM fá-lo sentir-se mais capaz de fazer o seu trabalho?',
  capable_label_line_2: 'Classifique de Menos Capaz (1) a Mais Capaz (10)',
  swipe_to_see_more: 'Deslize para ver mais',
  less_capable: 'menos capaz',
  most_capable: 'mais capaz',
  ways_used_line_1: 'Pense nas suas experiências de trabalho nos últimos dois meses. De que forma utilizou as competências e conhecimentos adquiridos através deste módulo online no seu trabalho diário?',
  ways_used_line_2: 'Forneça um exemplo que seja o mais específico possível.',
  write_your_answer_here: 'Escreva aqui a sua resposta...',
  measurable_improvement_label: `
  Em que {measurable_way} você tem visto uma melhoria em
  o desempenho do seu programa de imunização, como resultado das suas novas habilidades e conhecimentos?`,
  measurable_way: 'forma mensurável',
  anything_else_label: 'Há algo mais que você gostaria de compartilhar sobre o impacto da experiência de aprendizagem?',
  final_thanks: 'Obrigado pela sua participação nesta pesquisa e pelo seu compromisso com a sua profissão. Este foi o passo final do treino do MLM'
};

/**
 *
 * @type {{}}
 */
const reset_page = {

};

/**
 *
 * @type {{thank_you: string, response_message: string, email_label: string, country_label: string, h1: string, h2: string, describe_label: string, required: string, name_label: string, title_label: string}}
 */
const contact_modal = {
  h1: 'Contacto',
  h2: 'Contacte um oficial na sede da OMS AFRO em Brazzaville. Responderá à sua mensagem o mais rápido possível.',
  required: common.required,
  name_label: 'Nome',
  title_label: 'Título',
  email_label: common.email_label,
  country_label: common.country_label,
  describe_label: 'Descreva a sua necessidade de formação',
  thank_you: 'Obrigado.',
  response_message: 'Um oficial da sede da OMS AFRO em Brazzaville responderá à sua mensagem o mais rápido possível.',
};

/**
 *
 * @type {{role_name_label: string, register_now: string, last_name_label: string, basic_info: string, upload_new: string, password_label: string, first_name_label: string, h1: string, photo: string, h2: string, optional: string, contact_info: string, enroll_mlm_label: string, password_confirmation_label: string, registered_user: string, country_label: string, email_label: string, role_label: string, email_confirmation_label: string, sign_in: string}}
 */
const register_modal = {
  h1: 'Registe-se para começar com a Formação Online de GNM.',
  h2: 'É assim que o seu nome aparecerá em qualquer certificado que receber, por isso introduza o seu nome cuidadosamente.',
  registered_user: 'Utilizador registado?',
  sign_in: 'Inicie a sessão aqui.',
  basic_info: 'Informações Básicas',
  contact_info: 'Informações de Contacto',
  first_name_label: common.first_name_label,
  last_name_label: common.last_name_label,
  country_label: common.country_label,
  role_label: common.role_label,
  role_name_label: common.role_name_label,
  password_label: common.password_label,
  password_confirmation_label: 'Confirmação da Senha',
  email_label: common.email_label,
  email_confirmation_label: 'Confirme o Endereço de E-mail',
  photo: common.photo,
  optional: 'Opcional',
  upload_new: common.upload_new,
  enroll_mlm_label: 'Inscrever-se no Programa MLM Master',
  register_now: 'Registre-se agora',
};

/**
 *
 * @type {{email_label: string, password_label: string, or_register_an_account: string, h1: string, forgot_password: string}}
 */
const login_modal = {
  h1: 'Acesse a sua conta',
  email_label: common.email_label,
  password_label: common.password_label,
  forgot_password: 'Esqueceu a Senha',
  or_register_an_account: 'ou Registe uma Conta'
};

/**
 *
 * @type {{playback_step_1: string, playback_step_2: string, playback_step_3: string, back_btn_text: string, tour_btn_text: string, done_btn_text: string, start_step: string, next_btn_text: string, collaborate_step_2: string, collaborate_step_3: string, collaborate_step_4: string, collaborate_step_1_lg: string, collaborate_step_1_sm: string}}
 */
const tour = {
  start_step: 'Bem-vindo ao seu primeiro Curso de GNM!  Faça uma visita...',
  playback_step_1: 'O seu curso vai aparecer nesta área.',
  playback_step_2: 'Durante um curso, clique no botão SEGUINTE para avançar para o próximo ecrã do curso.',
  playback_step_3: 'Pode reiniciar ou revisitar qualquer secção do curso, clicando na mesma.',
  collaborate_step_1_sm: 'Pode mostrar/ocultar todas as secções do curso clicando aqui.',
  collaborate_step_1_lg: 'Faça o curso preencher o seu ecrã, clicando aqui.',
  collaborate_step_2: 'Partilhe as suas dúvidas, conhecimentos e dicas com outros profissionais do PAV que fazem este curso consigo.',
  collaborate_step_3: 'Cada curso inclui recursos úteis de que pode precisar. Baixe-os clicando nestes ícones.',
  collaborate_step_4: 'Se não conseguir encontrar as respostas de que necessita falando com outras pessoas no Fórum de Discussão, recomendamos que visite a Página de Ajuda online ',
  tour_btn_text: 'Faça uma visita',
  back_btn_text: 'Voltar',
  next_btn_text: 'Próximo',
  done_btn_text: 'Feito',
};

const workshops = {
  heading: 'A formação de Gestores de Nível Médio do PAV foi redesenhado para ser mais eficaz, flexível e interactivo. Cada módulo agora existe como um workshop e um e-módulo online - em inglês, francês e português. Baixe qualquer material do workshop abaixo.',
  redesigned_workshops: 'Workshops redesenhados',
  number_workshops: '17 workshops modularizados que podem ser realizados em qualquer combinação',
  guides: 'Guias do facilitador e dos participantes',
  instructions: 'Instruções minuto a minuto para os facilitadores que lideram cada workshop.',
  specific_points: 'Exercícios específicos, actividades e pontos da aula',
  structured_pedagogy: 'Apoio pedagógico estruturado ao longo de',
  workshops: 'Workshops',
  download_materials: 'Download de materiais',
  online_curriculum: 'Um currículo online',
  same_content: 'O mesmo conteúdo que os workshops',
  self_paced: 'Aprendizagem autogerida',
  highly_modular: 'Altamente modular',
  go_to: 'Ir para a Formação Online de GNM',
  courses: 'Cursos',
  about: 'Sobre',
  help: 'Ajuda',
  address: 'Organização Mundial de Saúde - Escritório Regional para a África Cité du Djoué, Caixa Postal 06 Brazzaville República do Congo',
  telephone: 'Telefone',
  fax: 'Fax',
}

/**
 *
 */
export default {
  ...common,
  nav,
  footer,
  home_page,
  help_page,
  about_page,
  courses_page,
  course_page,
  profile_page,
  profile_edit_page,
  survey_page,
  reset_page,
  contact_modal,
  register_modal,
  login_modal,
  tour,
  workshops,
}
